export default __webpack_public_path__ + "static/media/location.d665346a.svg";